import type { AudioNode } from './../../ricos-schema/next-schema';
import { Node_Type } from './../../ricos-schema/next-schema';
import type { PmAudioNode } from './../../_shared/pm-node-types';

export const fromPmAudioAnyState = (pmAudioNode: PmAudioNode): AudioNode => {
  const { id, ...audioData } = pmAudioNode?.attrs || {};

  const audio = audioData.audio
    ? audioData.audio
    : audioData.tempData
    ? fallbackAudio
    : fallbackAudio;

  return {
    type: Node_Type.AUDIO,
    id,
    audioData: {
      ...(audio ? { audio } : {}),
      ...(audioData.containerData ? { containerData: audioData.containerData } : {}),
      ...(audioData.disableDownload ? { disableDownload: audioData.disableDownload } : {}),
      ...(audioData.coverImage ? { coverImage: audioData.coverImage } : {}),
      ...(audioData.name ? { name: audioData.name } : {}),
      ...(audioData.authorName ? { authorName: audioData.authorName } : {}),
      ...(audioData.html ? { html: audioData.html } : {}),
    },
  };
};

// This is actual silent 1 second audio file
const fallbackAudio = {
  src: {
    id: '16f8d7_2ddc0cacfe7741b686d158405ad90527.mp3',
  },
};
